import GradientBlurb from './GradientBlurb';

export default GradientBlurb;
